import axios from 'axios';
import config from './config';

export const TOKEN_KEY = 'currencyToken';

const service = axios.create({
	baseURL: config.url,
	timeout: 90000,
});

service.interceptors.request.use(function (req) {
	const token = localStorage.getItem(TOKEN_KEY);
	// public endpoints (e.g. api/global/lookup) redirect when given a token
	if (token && !req.noAuth) {
		// web2 sends "Bearer<token>" without a space; keep it identical
		req.headers['Authorization'] = 'Bearer' + token;
	}
	return req;
});

service.interceptors.response.use(function (response) {
	return response;
}, function (error) {
	if (error.response && error.response.status == 401) {
		localStorage.removeItem(TOKEN_KEY);
		window.location.href = config.memberUrl;
	}
	return Promise.reject(error);
});

export default service;
